export const p100_22_base = [
  ['V50 P100动力电机', '电子件'],
  ['P100 电调', '电子件'],
  ['V50 P100 SuperX4 Pro飞控', '电子件'],
  ['V50 P100 摇摆雷达', '电子件'],
  ['V50 P100无刷喷头', '电子件'],
  ['V50 P100 蠕动泵A', '电子件'],
  ['V50 P100 蠕动泵B', '电子件'],
  ['V50 P100 地形模块', '电子件'],
  ['V50 P100 FPV相机', '电子件'],
  ['P100 中心舱集线板', '电子件'],
  ['V50 P100 喷洒线', '电子件'],
  ['V50 P100 UPS备用电池', '电子件'],
  ['P100 RTK天线-R', '电子件'],
  ['P100 RTK天线-L', '电子件'],
  ['P100 4G天线', '电子件'],
  ['P100 WiFi天线-L', '电子件'],
  ['P100 WiFi天线-R', '电子件'],
  ['P100 负载线', '电子件'],
  ['V50 P100 药箱传感器', '电子件'],
  ['P100 负载集线板睿喷连接线', '电子件'],
  ['V50 P100 P80升级版 甩盘电机线', '电子件'],
  ['V50 P100 P80升级版负载集线板PCBA', '电子件'],
  ['V50 P100 甩盘电机', '电子件'],
  ['V50 P100 料箱雷达', '电子件'],
  ['P100 绞龙电机减速组', '电子件'],
  ['P100 P80升级版负载集线板睿播连接线组件', '电子件'],
  ['V50 P100 睿图', '电子件'],
]
export const p100_22_advance = [
  ['V50 P100动力电机', '电子件'],
  ['P100 电调', '电子件'],
  ['V50 P100 SuperX4 Pro飞控', '电子件'],
  ['V50 P100 摇摆雷达', '电子件'],
  ['V50 P100无刷喷头', '电子件'],
  ['V50 P100 蠕动泵A', '电子件'],
  ['V50 P100 蠕动泵B', '电子件'],
  ['V50 P100 地形模块', '电子件'],
  ['V50 P100 FPV相机', '电子件'],
  ['P100 中心舱集线板', '电子件'],
  ['V50 P100 喷洒线', '电子件'],
  ['V50 P100 UPS备用电池', '电子件'],
  ['P100 RTK天线-R', '电子件'],
  ['P100 RTK天线-L', '电子件'],
  ['P100 4G天线', '电子件'],
  ['P100 WiFi天线-L', '电子件'],
  ['P100 WiFi天线-R', '电子件'],
  ['P100 负载线', '电子件'],
  ['V50 P100 药箱传感器', '电子件'],
  ['P100 负载集线板睿喷连接线', '电子件'],
  ['V50 P100 P80升级版 甩盘电机线', '电子件'],
  ['V50 P100 P80升级版负载集线板PCBA', '电子件'],
  ['V50 P100 甩盘电机', '电子件'],
  ['V50 P100 料箱雷达', '电子件'],
  ['P100 绞龙电机减速组', '电子件'],
  ['P100 P80升级版负载集线板睿播连接线组件', '电子件'],
  ['V50 P100 睿图', '电子件'],
  ['P100 负载主框', '结构件'],
  ['P100 机臂', '结构件'],
  ['P100 边梁(含卡簧）', '结构件'],
  ['P100 头罩框架', '结构件'],
  ['P100 汇流板（含O型圈）', '结构件'],
  ['P100 负载框脚架固定件', '结构件'],
  ['P100 药箱底部支撑杆', '结构件'],
  ['P100 机头罩', '结构件'],
  ['V50 P100 睿播播撒器主框', '结构件'],
  ['P80 P100 机臂固定滑块', '结构件'],
  ['P100 药箱脚架内侧固定件', '结构件'],
  ['P100 电调端子固定座', '结构件'],
  ['P100 快拆搭扣(含卡簧）', '结构件'],
  ['P100 横梁', '结构件'],
  ['P100 搭扣底座(含卡簧）', '结构件'],
  ['V50 P100 电机座钢套', '结构件'],
  ['P80 P100 动力电机减震固定座', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮-绞龙端', '结构件'],
  ['P100 中心舱盖', '结构件'],
  ['M5*16内六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 机头红色支撑杆', '结构件'],
  ['M3*8*6内六角圆柱头三组合螺丝', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮-电机端', '结构件'],
  ['P100 尾框横梁', '结构件'],
  ['P100 机臂防撞胶', '结构件'],
  ['V50 P100 电调端子支撑管2（短）', '结构件'],
  ['M4*10*8内六角圆柱头三组合螺丝', '结构件'],
  ['V50 P100 P80升级版睿播播撒器主框', '结构件'],
  ['M5*22*10内六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 机身载荷对接件', '结构件'],
  ['P100 蠕动泵固定件', '结构件'],
  ['P80 P100 机臂机身端旋转件', '结构件'],
  ['V50 P100P80升级版电池导轨套件', '结构件'],
  ['P100 天线遮盖件', '结构件'],
  ['P100 药箱防震胶垫', '结构件'],
  ['M2.5*8*4.5内六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 机臂防撞胶压件', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙管抱紧卡扣', '结构件'],
  ['ST4.2*8PB 内六角圆柱头平尾自攻螺丝', '结构件'],
  ['P100 摇摆雷达固定件', '结构件'],
  ['V50 P100 电调端子保护盖', '结构件'],
  ['P100 药箱脚架外侧固定件', '结构件'],
  ['M5*32内六角三组合耐落螺丝', '结构件'],
  ['P100 机身载荷对接件软胶', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙电机罩', '结构件'],
  ['P100汇流板螺钉绝缘套', '结构件'],
  ['P100 机身把手', '结构件'],
  ['M6*16内六角圆柱头三组合螺丝', '结构件'],
  ['M4*10*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['P80 P100 主体框架防摩擦棉', '结构件'],
  ['P100 天线支架', '结构件'],
  ['M5*10*10内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M4*18*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['ST2.9*8PB 内六角圆柱头平尾自攻螺丝', '结构件'],
  ['M4*16*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 机臂软胶支撑', '结构件'],
  ['M4*40*8内六角圆柱头三组合耐落螺丝', '结构件'],
  ['V50 P100 P80升级版睿播绞龙对接轴', '结构件'],
  ['M3*14*6内六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 头罩固定管', '结构件'],
  ['P100 快拆把手转轴', '结构件'],
  ['M4*8*8内六角圆柱头三组合耐落螺丝', '结构件'],
  ['ST2.9*10PB内六角圆柱头自攻螺丝', '结构件'],
  ['P100 电池尾插下壳', '结构件'],
  ['M2*8*4内六角三组合螺丝', '结构件'],
  ['M4*14*9内六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 机头支撑固定件-左', '结构件'],
  ['P100 水泵对接件药箱固定件', '结构件'],
  ['P100 机头支撑固定件-右', '结构件'],
  ['P100 机臂传输管防磨橡胶', '结构件'],
  ['ST4.2*14PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST2.9*8PB内六角圆柱头自攻螺丝', '结构件'],
  ['ST4.2*10PA内六角圆柱头尖脚自攻螺丝', '结构件'],
  ['M6*22*12内六角圆柱头三组合螺丝', '结构件'],
  ['V50 P100 P80升级版睿播同步齿轮轴锁紧件', '结构件'],
  ['P100 机身部分底部挡板', '结构件'],
  ['P100 负载框胶塞', '结构件'],
  ['悬挂固定挂钩', '结构件'],
  ['M4*12内六角沉头螺丝（耐落)', '结构件'],
  ['ST2.9*5PB内六角圆柱头自攻螺丝', '结构件'],
  ['V50 P100 P80升级版负载集线板下盖', '结构件'],
  ['P100 把手天线口盖2', '结构件'],
  ['P100 把手天线口盖1', '结构件'],
  ['V50 P100 P80升级版睿播同步齿轮盖', '结构件'],
  ['P100 头罩卡线件', '结构件'],
  ['M3*8六角圆柱头三组合耐落螺丝', '结构件'],
  ['P100 负载框线扣', '结构件'],
  ['P100 负载框线束固定件', '结构件'],
  ['M4*8平头内六角耐落螺丝', '结构件'],
  ['P100 4G天线压盖', '结构件'],
  ['V50 P100 P80升级版 睿播绞龙电机散热硅胶', '结构件'],
  ['V50 P100 P80升级版睿播绞龙骨架油封', '结构件'],
  ['V50 P100 P80升级版睿播绞龙卡扣转轴', '结构件'],
  ['V50 P100 P80升级版负载集线板上盖', '结构件'],
  ['P100 机头卡线件', '结构件'],
  ['P100 馈线卡线架', '结构件'],
  ['V50 P100地形模块光流盖', '结构件'],
  ['M2*8*4内六角三组合耐落螺丝', '结构件'],
  ['P100 电池尾插上壳', '结构件'],
  ['V50 P100 P80升级版  睿播出料口-左挡片', '结构件'],
  ['M3*8开口型平圆头抽芯铆钉', '结构件'],
  ['P100 主体连接铝型材护线件', '结构件'],
  ['机身端药管固定件', '结构件'],
  ['P100 汇流板O型圈', '结构件'],
  ['V50 P100 P80升级版睿播绞龙卡扣Ø3.5卡簧', '结构件'],
  ['V50 P100 P80升级版睿播绞龙电机线卡线EVA棉', '结构件'],
  ['M2.4*6开口型平圆头抽芯铆钉', '结构件'],
  ['V50 P100 P80升级版  睿播甩盘电机线R型理线夹', '结构件'],
  ['M5*22*10内六角圆柱头三组合螺丝', '结构件'],
  ['P100 60L料箱脚架卡管外钣金件', '结构件'],
  ['P100 睿图挂载板', '结构件'],
  ['M2*4圆柱头内六角耐落螺丝', '结构件'],
  ['P100 汇流板螺钉胶塞', '结构件'],
  ['固定连接器EVA棉', '结构件'],
  ['V50 P100 P80升级版睿播绞龙中轴出料口O型硅胶圈', '结构件'],
  ['V50 P100 P80升级版负载集线盒防水橡胶圈', '结构件'],
  ['V50 P100 P80升级版睿播绞龙同步齿轮电机端中轴O型硅胶圈', '结构件'],
  ['P100 负载线端子固定件', '结构件'],
  ['P100 机头罩固定管卡件-后', '结构件'],
  ['P100 机头罩固定管卡件-前', '结构件'],
  ['V50 P100 飞控4PIN线堵头', '结构件'],
  ['V50 P100 睿图塑胶减震结构支架', '结构件'],
  ['V50 P100 睿图塑胶减震结构', '结构件'],
  ['M5*20定制版内六角螺丝', '结构件'],
  ['V50 P100 P80升级版电池导轨胶垫', '结构件'],
  ['P100 药管固定橡胶', '结构件'],
  ['P100 甩盘电机线卡扣件', '结构件'],
  ['V50 P100 电调端子支撑管1（长）', '结构件'],
  ['V50 P100 P80升级版绞龙电机减速箱硅胶O型圈', '结构件'],
  ['V50 P100 负载连接线接头卡件', '结构件'],
  ['M5X20定制螺钉返工半成品组件', '结构件'],
  ['2.4X8铆钉', '结构件'],
  ['M6*22*12内六角圆柱头三组合耐落螺丝', '结构件'],
  ['M6*40*12内六角圆柱头三组合螺丝', '结构件'],
  ['P100 60L料箱脚架橡胶防护片', '结构件'],
  ['P100搭扣自锁保险扣', '结构件'],
  ['醋酸胶布', '结构件'],
]
